module.exports = __webpack_public_path__ + "static/media/transcript.1eee7c4a.png";